import * as yup from "yup";

const validationSchema = yup.object().shape({
  memId: yup.string().optional("Please Select Affiliate Name"),
  service: yup.string().required("Please Select Affiliate Service"),
  bookingId: yup.string().required("Booking ID is required"),
  hsnNumber: yup.string().required("HSN Number is required"),
  CheckInDate: yup.string().required("Check In Date is required"),
  CheckOutDate: yup.string().required("Check Out Date is required"),
  roomInfo: yup
    .array()
    .of(
      yup.object().shape({
        numberOfAdults: yup
          .number()
          .min(1, "At least 1 adult is required")
          .max(10, "Maximum 4 adults per room")
          .required("Number of adults is required"),
        numberOfChild: yup
          .number()
          .min(0)
          .max(5, "Maximum 3 children per room")
          .required("Number of children is required"),
      })
    )
    .min(1, "At least one room is required")
    .max(10, "Maximum 5 rooms allowed"),
  address: yup.object().shape({
    adr: yup.string().required("Hotel Address is required"),
    postalCode: yup
      .string()
      .required("Postal Code / Pin Code /Area Code is required"),
    // .matches(/^\d{4,10}$/, "Postal code must be 4-10 digits"), // customize pattern as needed
  }),
  cnt: yup.object().shape({
    ph: yup.string().required("Contact number is required"),
    // .matches(/^\d{10,15}$/, "Phone number must be 10-15 digits"),
  }),
  price: yup.object().shape({
    TF: yup
      .number()
      .typeError("Total Fare must be a number")
      .min(0, "Total Fare cannot be negative")
      .required("Total Fare vis required"),

    BF: yup
      .number()
      .typeError("Total Base Fare must be a number")
      .min(0, "Total Base Fare cannot be negative")
      .required("Total Base Fare is required"),

    NF: yup
      .number()
      .typeError("Total Net Fare must be a number")
      .min(0, "Total Net Fare cannot be negative")
      .required("Total Net Fare is required"),

    TAF: yup
      .number()
      .typeError("Total Tax Fare must be a number")
      .min(0, "Total Tax Fare cannot be negative")
      .required("Tax Fare is required"),
  }),
  userMarkup: yup
    .number()
    .typeError("User Markup must be a number")
    .min(0, "User Markup cannot be negative")
    .required("User Markup is required"),

  adminMarkup: yup
    .number()
    .typeError("Admin Markup must be a number")
    .min(0, "Admin Markup cannot be negative")
    .required("Admin Markup is required"),
  rating: yup
    .number()
    .typeError("Rating must be a number")
    .min(1, "Minimum rating is 1")
    .max(10, "Maximum rating is 10")
    .required("Rating is required"),
  hotelName: yup.string().trim().required("Hotel name is required"),
  cancellation: yup.object().shape({
    id: yup.string().optional("Cancellation ID is required"),
    pd: yup
      .array()
      .of(
        yup.object().shape({
          // fdt: yup
          //   .date()
          //   .typeError("From Date must be a valid date")
          //   .required("From Date is required"),
          // tdt: yup
          //   .date()
          //   .typeError("To Date must be a valid date")
          //   .min(yup.ref("fdt"), "To Date must be after or equal to From Date")
          //   .required("To Date is required"),
          am: yup
            .number()
            .typeError("Amount must be a number")
            .min(0, "Amount cannot be negative")
            .required("Amount is required"),
        })
      )
      .min(1, "At least one cancellation policy must be defined"),
  }),

  roomDetails: yup.array().of(
    yup.object().shape({
      ti: yup
        .array()
        .of(
          yup.object().shape({
            ti: yup.string().required("Title is required"),
            pt: yup.string().required("Guest Type is required"),
            fN: yup.string().required("First name is required"),
            lN: yup.string().required("Last name is required"),
            // pNum: yup.string().required("Phone number is required"),
          })
        )
        .min(1, "At least one traveler information is required"),
    })
  ),
});

//
const OfflineModel = {
  memId: "",
  balance: "",
  service: 1,
  userMarkup: 0,
  adminMarkup: 0,
  bookingId: "",
  hsnNumber: "",
  CheckInDate: new Date(), // <- Use Date object
  CheckOutDate: new Date(new Date().setDate(new Date().getDate() + 1)),
  hotelName: "",
  rating: 3,
  cnt: {
    ph: "",
  },
  gl: {
    ln: "",
    lt: "",
  },
  des: "", // <- Use Date object
  roomInfo: [
    {
      numberOfAdults: 1,
      numberOfChild: 0,
    },
  ],
  roomDetails: [
    {
      id: "",
      rc: "",
      rt: "",
      srn: "",
      adt: 1,
      chd: 0,
      // pdes: [],
      mb: "ROOM ONLY",
      tp: 0,
      tfcs: {
        BF: 0,
        NF: 0,
        CMU: 0,
        TAF: 0,
        TF: 0,
      },
      // tafcs: {
      //   TAF: {
      //     MF: 0,
      //     SBP: 0,
      //     PRF: 0,
      //     SNP: 0,
      //     MFT: 0,
      //     SRC: 0,
      //     IGST: 0,
      //     SGP: 0,
      //     TTSF: 0,
      //     SAC: 0,
      //     TMF: 0,
      //     TSF: 0,
      //   },
      // },
      ddt: new Date(),
      pis: [
        {
          day: 1,
          fc: {
            BF: 0,
            NF: 0,
            TF: 0,
            CMU: 0,
            TAF: 0,
          },
          // afc: {
          //   TAF: {
          //     MF: 10,
          //     SBP: 0,
          //     PRF: 0,
          //     SNP: 0,
          //     MFT: 0,
          //     SRC: 0,
          //     IGST: 0,
          //     SGP: 0,
          //     TTSF: 0,
          //     SAC: 0,
          //     TMF: 0,
          //     TSF: 0,
          //   },
          // },
        },
      ],
      CheckInDate: new Date(), // <- Use Date object
      CheckOutDate: new Date(new Date().setDate(new Date().getDate() + 1)),
      ti: [
        {
          ti: "Mr",
          pt: "ADULT",
          fN: "",
          lN: "",
          pNum: "",
          pan: "",
        },
      ],
      ispfap: false,
      iopr: false,
      radi: {
        rid: "0",
        mga: 0,
        maa: 0,
        mca: 0,
        bds: [
          {
            bt: "Double",
            bc: 1,
          },
        ],
        // ar: {},
      },
      // op: "1",
      rexb: "",
      //  {
      //   // BENEFIT: [
      //   //   {
      //   //     values: [
      //   //       // "Free breakfast",
      //   //       // "Room service",
      //   //       // "Free self parking",
      //   //       // "Free WiFi",
      //   //     ],
      //   //   },
      //   // ],
      // },
      // rsta: "PS",
    },
  ],
  cancellation: {
    id: "",
    pd: [
      {
        fdt: new Date(),
        tdt: new Date(),
        am: 0,
      },
    ],
  },
  address: {
    adr: "",
    postalCode: "",
    city: {
      name: "",
    },
    state: {
      name: "",
    },
    country: {
      code: "",
      name: "",
    },
    ctn: "",
    sn: "",
    cn: "",
  },
  searchCriteria: {
    cityName: "",
    cityId: "",
    countryName: "",
    countryId: 1,
    nationality: "",
  },
  price: {
    TF: 0,
    BF: 0,
    NF: 0,
    TAF: 0,
  },
};

export { OfflineModel, validationSchema };
